export default "__VITE_ASSET__CHIFO9cM__"